import { GlButton, GlAvatar, GlAvatarLink, GlAvatarsInline, GlTooltipDirective } from '@gitlab/ui';
import { __, n__ } from '~/locale';
export default {
    name: 'ToggleNotesWidget',
    components: {
        GlButton,
        GlAvatar,
        GlAvatarLink,
        GlAvatarsInline
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        collapsed: {
            type: Boolean,
            required: true
        },
        replies: {
            type: Array,
            required: true
        }
    },
    emits: [
        'toggle'
    ],
    computed: {
        iconName () {
            return this.collapsed ? 'chevron-right' : 'chevron-down';
        },
        toggleText () {
            return this.collapsed ? n__('%d reply', '%d replies', this.replies.length) : __('Collapse replies');
        },
        authors () {
            return [
                ...new Set(this.replies.map((item)=>item.author))
            ];
        },
        authorCollapsedTooltip () {
            if (this.authors.length > 2) {
                return n__('%d reply', '%d replies', this.authors.length);
            }
            return '';
        },
        ariaState () {
            return String(!this.collapsed);
        }
    }
};
